import { render, staticRenderFns } from "./LanguageFormModal.vue?vue&type=template&id=32872354&"
import script from "./LanguageFormModal.vue?vue&type=script&lang=js&"
export * from "./LanguageFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports